import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';
import { Breadcrumbs } from './breadcrumbs';
import { ExitIntentPopup } from '../ui/exit-intent-popup';
import { StickyCTABar } from '../ui/sticky-cta-bar';
import { SmartBanner } from '../ui/smart-banner';
import { StructuredData } from '../seo/structured-data';

export function MainLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white overflow-visible">
      <StructuredData type="localBusiness" />
      {/* Skip to Content Link for Screen Readers */}
      <a
        href="#main-content"
        className="skip-to-content"
        aria-label="Skip to main content"
      >
        Skip to Content
      </a>
      <Header />
      <SmartBanner 
        position="top"
        dismissible={true}
        autoRotate={false}
        showOnPages={['/', '/services', '/contact', '/about']}
      />
      <Breadcrumbs />
      <main
        id="main-content"
        className="flex-1 overflow-visible pb-[calc(var(--sticky-cta-offset,0px)+env(safe-area-inset-bottom,0px))]"
        role="main"
        aria-label="Main content"
      >
        <Outlet />
      </main>
      <Footer />
      <ExitIntentPopup />
      <StickyCTABar />
    </div>
  );
}
